/* Existing review-media tuning and consent-aware web-vitals reporting. No legacy image/font preloads or old layout containment. */
(function () {
    function tuneReviewMedia(root) {
      if (!root || root.nodeType !== 1) return;
      var scope = root.matches && root.matches('[id*="__loox"], .loox-widget, .loox-reviews-default, .loox-aggregate-reviews')
        ? root
        : root.querySelector && root.querySelector('[id*="__loox"], .loox-widget, .loox-reviews-default, .loox-aggregate-reviews');
      if (!scope) return;
      scope.querySelectorAll('img').forEach(function (image) {
        image.loading = 'lazy';
        image.decoding = 'async';
        image.fetchPriority = 'low';
      });
      scope.querySelectorAll('iframe').forEach(function (frame) {
        frame.loading = 'lazy';
        frame.setAttribute('fetchpriority', 'low');
      });
      scope.querySelectorAll('video').forEach(function (video) {
        if (!video.hasAttribute('preload')) video.preload = 'metadata';
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[id*="__loox"], .loox-widget, .loox-reviews-default, .loox-aggregate-reviews').forEach(tuneReviewMedia);
      new MutationObserver(function (records) {
        records.forEach(function (record) { record.addedNodes.forEach(tuneReviewMedia); });
      }).observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  })();

(function () {
    if (!('PerformanceObserver' in window)) return;

    var values = { LCP: 0, CLS: 0, INP: 0 };
    var observed = { LCP: false, CLS: true, INP: false };
    var sent = {};
    var metricId = 'pj-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    var navigationEntry = performance.getEntriesByType('navigation')[0];
    var navigationType = navigationEntry && navigationEntry.type ? navigationEntry.type : 'navigate';

    function analyticsAllowed() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
    }

    function rating(name, value) {
      var thresholds = name === 'LCP' ? [2500, 4000] : name === 'CLS' ? [0.1, 0.25] : [200, 500];
      return value <= thresholds[0] ? 'good' : value <= thresholds[1] ? 'needs-improvement' : 'poor';
    }

    function report(name) {
      if (sent[name] || !observed[name] || !analyticsAllowed()) return;
      if (typeof window.gtag !== 'function' && !Array.isArray(window.dataLayer)) return;

      sent[name] = true;
      var params = {
        metric_name: name,
        metric_value: Math.round(values[name] * (name === 'CLS' ? 1000 : 1)) / (name === 'CLS' ? 1000 : 1),
        metric_id: metricId + '-' + name.toLowerCase(),
        metric_delta: Math.round(values[name] * (name === 'CLS' ? 1000 : 1)) / (name === 'CLS' ? 1000 : 1),
        metric_rating: rating(name, values[name]),
        page_path: location.pathname,
        navigation_type: navigationType,
        non_interaction: true
      };

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'web_vitals', params);
      } else {
        window.dataLayer.push(['event', 'web_vitals', params]);
      }
    }

    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        if (entries.length) {
          values.LCP = entries[entries.length - 1].startTime;
          observed.LCP = true;
        }
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (error) {}

    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (!entry.hadRecentInput) values.CLS += entry.value;
        });
      }).observe({ type: 'layout-shift', buffered: true });
    } catch (error) {}

    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          values.INP = Math.max(values.INP, entry.duration || 0);
          observed.INP = true;
        });
      }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (error) {}

    function flush() {
      report('LCP');
      report('CLS');
      report('INP');
    }

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });
    addEventListener('pagehide', flush, { once: true });
  })();
